import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GppMaybeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gpp_maybe"}/>
}
